module.exports = __webpack_public_path__ + "img/2.46857fc9.jpg";